<template>
  <div>
    <form v-show="false" id="f1" name="f1" action="#" method="post" class="alignet-form-vpos2">
      <table aria-hidden="true">
        <tr>
          <td>acquirerId</td>
          <td>
            <input type="text" name="acquirerId" :value="dataPayme.acquirerId" />
          </td>
        </tr>
        <tr>
          <td>idCommerce</td>
          <td>
            <input type="text" name="idCommerce" :value="dataPayme.idCommerce" />
          </td>
        </tr>
        <tr>
          <td>purchaseOperationNumber</td>
          <td>
            <input type="text" name="purchaseOperationNumber" :value="dataPayme.purchaseOperationNumber" />
          </td>
        </tr>
        <tr>
          <td>purchaseAmount</td>
          <td>
            <input type="text" name="purchaseAmount" :value="dataPayme.purchaseAmount" />
          </td>
        </tr>
        <tr>
          <td>purchaseCurrencyCode</td>
          <td>
            <input type="text" name="purchaseCurrencyCode" :value="dataPayme.purchaseCurrencyCode" />
          </td>
        </tr>
        <tr>
          <td>language</td>
          <td>
            <input type="text" name="language" :value="dataPayme.language" />
          </td>
        </tr>
        <tr>
          <td>shippingFirstName</td>
          <td>
            <input type="text" name="shippingFirstName" :value="dataPayme.shippingFirstName" />
          </td>
        </tr>
        <tr>
          <td>shippingLastName</td>
          <td>
            <input type="text" name="shippingLastName" :value="dataPayme.shippingLastName" />
          </td>
        </tr>
        <tr>
          <td>shippingEmail</td>
          <td>
            <input type="text" name="shippingEmail" :value="dataPayme.shippingEmail" />
          </td>
        </tr>
        <tr>
          <td>shippingAddress</td>
          <td>
            <input type="text" name="shippingAddress" :value="dataPayme.shippingAddress" />
          </td>
        </tr>
        <tr>
          <td>shippingZIP</td>
          <td>
            <input type="text" name="shippingZIP" :value="dataPayme.shippingZIP" />
          </td>
        </tr>
        <tr>
          <td>shippingCity</td>
          <td>
            <input type="text" name="shippingCity" :value="dataPayme.shippingCity" />
          </td>
        </tr>
        <tr>
          <td>shippingState</td>
          <td>
            <input type="text" name="shippingState" :value="dataPayme.shippingState" />
          </td>
        </tr>
        <tr>
          <td>shippingCountry</td>
          <td>
            <input type="text" name="shippingCountry" :value="dataPayme.shippingCountry" />
          </td>
        </tr>
        <tr>
          <td>userCommerce</td>
          <td>
            <input type="text" name="userCommerce" value="modalprueba1" />
          </td>
        </tr>
        <tr>
          <td>userCodePayme</td>
          <td><input type="text" name="userCodePayme" value="" /></td>
        </tr>
        <tr>
          <td>descriptionProducts</td>
          <td>
            <input type="text" name="descriptionProducts" :value="dataPayme.descriptionProducts" />
          </td>
        </tr>
        <tr>
          <td>programmingLanguage</td>
          <td>
            <input type="text" name="programmingLanguage" :value="dataPayme.programmingLanguage" />
          </td>
        </tr>
        <tr>
          <td>reserved1</td>
          <td><input type="text" name="reserved1" value="reserved1" /></td>
        </tr>
        <tr>
          <td>reserved2</td>
          <td>
            <input type="text" name="reserved2" :value="dataPayme.reserved2" />
          </td>
        </tr>
        <tr>
          <td>reserved3</td>
          <td>
            <input type="text" name="reserved3" :value="dataPayme.reserved3" />
          </td>
        </tr>
        <tr>
          <td>reserved4</td>
          <td>
            <input type="text" name="reserved4" :value="dataPayme.reserved4" />
          </td>
        </tr>
        <tr>
          <td>reserved6</td>
          <td>
            <input type="text" name="reserved6" :value="dataPayme.reserved6" />
          </td>
        </tr>
        <tr>
          <td>reserved7</td>
          <td>
            <input type="text" name="reserved7" :value="dataPayme.reserved7" />
          </td>
        </tr>
        <tr>
          <td>purchaseVerification</td>
          <td>
            <input type="text" name="purchaseVerification" :value="dataPayme.purchaseVerification" />
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <v-btn ref="paymeForm" :color="color" class="fb-btn" elevation="1" outlined rounded x-large width="250px" value="Comprar" @click="openModal()">
              <v-row align="center" class="spacer" no-gutters>
                <v-col cols="2" xs="1" sm="2" md="2">
                  <v-img :src="setImage()"> </v-img>
                </v-col>
                <v-divider vertical style="margin-left: 5%"></v-divider>
                <v-col>
                  {{ data.orchestratorName }}
                </v-col>
              </v-row>
            </v-btn>
          </td>
        </tr>
      </table>
    </form>
    <v-btn
      :color="color"
      class="fb-btn text-none"
      :class="!$vuetify.breakpoint.xs ? 'px-3 py-3' : 'px-3 py-2'"
      block
      outlined
      style="height: max-content; letter-spacing: normal; display: inline-table"
      value="Comprar"
      @click="getValues()">
      <v-row align="center" no-gutters>
        <v-col>
          <v-row no-gutters>
            <v-col class="d-flex" cols="12" style="align-items: center">
              <v-img class="mr-4" style="border-radius: 5px; max-width: 30px; max-height: 30px" :src="setImage()" @error="handleImageError"></v-img>
              <div>
                <span class="font-weight-medium d-block" style="font-size: 15px; color: #333333; white-space: normal; line-height: 18px; text-align: left">
                  {{ processorName }}
                </span>
                <span
                  v-if="processorLegend && processorLegend !== '' && $vuetify.breakpoint.xs"
                  class="font-weight-regular d-block pt-1"
                  style="font-size: 12px; color: #545454; white-space: normal; line-height: 14px; text-align: left">
                  {{ processorLegend }}
                </span>
              </div>
            </v-col>
          </v-row>
          <v-row v-if="processorLegend && processorLegend !== '' && !$vuetify.breakpoint.xs" no-gutters>
            <v-col class="d-flex mt-1" cols="12" style="text-align: left">
              <span class="font-weight-regular" style="font-size: 11px; color: #545454; white-space: normal; line-height: 14px">
                {{ processorLegend }}
              </span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-btn>

    <v-overlay v-if="overlay" :absolute="absolute">
      <v-row class="fill-height" align-content="center" justify="center">
        <v-col class="text-subtitle-1 text-center" cols="12"> {{ $t(`paymeComponent.overlayMessage.${overlayMessage}`) }} </v-col>
        <v-col cols="12">
          <v-progress-linear v-if="progress" :color="color" indeterminate rounded height="10"></v-progress-linear>
        </v-col>
      </v-row>
    </v-overlay>
  </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex'

export default {
  name: 'PayMe',
  props: ['data'],
  data: () => ({
    url: null,
    imageLoaded: false,
    imageError: false,
    overlay: false,
    progress: false,
    overlayMessage: 'loading',
    dataPayme: {
      acquirerId: '',
      idCommerce: '',
      purchaseOperationNumber: '',
      purchaseAmount: '',
      purchaseCurrencyCode: '',
      language: '',
      shippingFirstName: '',
      shippingLastName: '',
      shippingEmail: '',
      shippingAddress: '',
      shippingZIP: '',
      shippingCity: '',
      shippingState: '',
      shippingCountry: '',
      userCommerce: '',
      userCodePayme: '',
      descriptionProducts: '',
      programmingLanguage: '',
      reserved1: '',
      reserved2: '',
      reserved3: '',
      reserved4: '',
      reserved6: '',
      reserved7: '',
      purchaseVerification: ''
    }
  }),
  computed: {
    ...mapState(['paymeData', 'color', 'x_country', 'x_commerce', 'x_customerid']),
    processorName() {
      return this.data?.processors[0]?.processorName[this.$t(`paymeComponent.processorName`)]
    },
    processorLegend() {
      return this.data?.processors[0]?.processorLegend?.[this.$t(`yunoComponent.processorLegend`)]
    }
  },
  watch: {
    paymeData: function () {
      this.dataPayme.acquirerId = this.paymeData.json.client.acquirerId
      this.dataPayme.idCommerce = this.paymeData.json.client.commerceId
      this.dataPayme.language = this.paymeData.json.client.language
      this.dataPayme.shippingFirstName = this.paymeData.json.client.firstName
      this.dataPayme.shippingLastName = this.paymeData.json.client.lastName
      this.dataPayme.shippingEmail = this.paymeData.json.client.email
      this.dataPayme.shippingAddress = this.paymeData.json.client.shippingAddressLine1
      this.dataPayme.shippingZIP = this.paymeData.json.client.shippingAddressZipCode
      this.dataPayme.shippingCity = this.paymeData.json.client.shippingAddressCity
      this.dataPayme.shippingState = this.paymeData.json.client.shippingAddressState
      this.dataPayme.shippingCountry = this.paymeData.json.client.shippingAddressCountry
      this.dataPayme.userCommerce = this.paymeData.json.client.userCommerce
      this.dataPayme.userCodePayme = this.paymeData.json.client.userCodePayme
      this.dataPayme.programmingLanguage = this.paymeData.json.client.programmingLanguage
      this.dataPayme.reserved2 = this.paymeData.json.client.reserved2
      this.dataPayme.reserved3 = this.paymeData.json.client.reserved3
      this.dataPayme.reserved4 = this.paymeData.json.client.reserved4
      this.dataPayme.reserved6 = process.env.VUE_APP_ENV
      this.dataPayme.reserved7 = this.paymeData.json.client.reserved7
      this.dataPayme.purchaseOperationNumber = this.paymeData.json.checkout.merchantOrderId
      this.dataPayme.purchaseAmount = this.paymeData.json.checkout.amountValue
      this.dataPayme.purchaseCurrencyCode = this.paymeData.json.checkout.amountCurrency
      this.dataPayme.descriptionProducts = this.paymeData.json.checkout.paymentDescription
      this.dataPayme.purchaseVerification = this.paymeData.modalHash.hash
      console.log('Soy this.dataPayme:', this.dataPayme)

      setTimeout(() => {
        this.$refs.paymeForm.$el.click()
      }, 1000)
    }
  },
  created() {
    //this.url = this.data.processors[0].URL_Widget
  },
  mounted() {
    const image = new Image()
    image.src = this.setImage()
    image.onload = () => {
      this.imageLoaded = true
      this.$emit('loaded')
    }
    image.onerror = () => {
      this.imageError = true
      this.$emit('loaded')
    }
  },
  methods: {
    ...mapMutations(['getSessionCache']),
    setImage() {
      return `${process.env.VUE_APP_STORAGE}${this.data.processors[0].processorType}.png`
    },
    handleImageError() {
      this.imageError = true // Marcar que ha ocurrido un error al cargar la imagen
    },
    getValues() {
      this.overlay = true
      this.progress = true
      let formattedName = this.data.orchestratorName.split(' ').join('').toUpperCase()
      this.getSessionCache(formattedName)
    },
    openModal() {
      const script = document.createElement('script')
      script.textContent = `AlignetVPOS2.openModal('${process.env.VUE_APP_URL_MODAL}', '1')`
      document.body.appendChild(script)
      this.overlay = false
      this.progress = false
    },
    clickModal() {
      console.log('payme component', this.dataPayme)
      this.$refs.paymeForm.$el.click()
    }
  }
}
</script>

<style scoped>
.invisible {
  display: none;
}
</style>
